// Pure class-composition seam for single-line and multi-line text fields. Mirrors
// button-classes.ts: one place owns the look, the components in TextField.tsx are
// thin consumers. `className` is for layout only (mt-1, max-w-*), never for
// restyling; a sizing or colour need there means the seam needs a variant.

export interface TextFieldClassesOptions {
  /** Monospace at 12px for prompts, templates and other line-scanned text. */
  mono?: boolean;
  /** Textarea: allow vertical resize. */
  multiline?: boolean;
  className?: string;
}

// Rounded bg-surface with an ink-ui ring: the ring is what tells a field apart
// from the card it sits on, so it carries the 3:1 non-text contrast (WCAG
// 1.4.11); focus thickens it to full ink. Disabled doubles as the read-only
// look (empty-state wash, ink-disabled text), so callers never invent a
// separate read-only style.
const BASE =
  "smycles-field-value w-full rounded-md bg-surface px-3 py-2.5 text-ink ring-1 ring-ink-ui transition " +
  "placeholder:text-ink-muted focus:outline-none focus:ring-2 focus:ring-ink " +
  "disabled:cursor-not-allowed disabled:bg-ink/[0.02] disabled:text-ink-disabled";

const MONO = "font-mono text-smycles-meta leading-relaxed";
const MULTILINE = "resize-y";

export function textFieldClasses({
  mono = false,
  multiline = false,
  className = "",
}: TextFieldClassesOptions = {}): string {
  return [BASE, mono ? MONO : "", multiline ? MULTILINE : "", className].filter(Boolean).join(" ");
}
